/**
 * Extract the 11-char YouTube video id from a watch/share/embed URL. Falls back
 * to the raw string when it's already a bare id (or unparseable).
 */
export const getYouTubeId = (link: string | null | undefined): string => {
  if (!link) return ''
  const match = link.match(/(?:youtu\.be\/|v=|embed\/)([^?&/]+)/)
  return match?.[1] ?? link
}

/** Public thumbnail for a YouTube id (always exists, unlike maxresdefault). */
export const getYouTubeThumbnail = (id: string): string => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`

/** Canonical embed URL — used for VideoObject structured data. */
export const getYouTubeEmbedUrl = (id: string): string => `https://www.youtube.com/embed/${id}`
